import { create } from 'zustand'
import { useEffect } from 'react'
import { CheckCircle2, XCircle, Info, X } from 'lucide-react'

type ToastType = 'success' | 'error' | 'info'
interface ToastItem { id: string; type: ToastType; message: string }

interface ToastState {
  items: ToastItem[]
  push: (type: ToastType, message: string) => void
  dismiss: (id: string) => void
}

export const useToast = create<ToastState>((set, get) => ({
  items: [],
  push: (type, message) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
    set({ items: [...get().items, { id, type, message }] })
    setTimeout(() => get().dismiss(id), 3500)
  },
  dismiss: (id) => set({ items: get().items.filter((x) => x.id !== id) }),
}))

const ICONS = {
  success: CheckCircle2,
  error:   XCircle,
  info:    Info,
}
const STYLES: Record<ToastType, string> = {
  success: 'bg-green-50 border-green-200 text-green-800',
  error:   'bg-red-50 border-red-200 text-red-800',
  info:    'bg-blue-50 border-blue-200 text-blue-800',
}

export function ToastContainer() {
  const items = useToast((s) => s.items)
  const dismiss = useToast((s) => s.dismiss)

  useEffect(() => { /* noop */ }, [items])

  return (
    <div className="fixed top-5 right-5 z-[60] space-y-2 w-[340px] max-w-[calc(100vw-40px)]">
      {items.map((t) => {
        const Icon = ICONS[t.type]
        return (
          <div
            key={t.id}
            className={[
              'rounded-lg border px-4 py-3 shadow-hover flex items-start gap-3 animate-in slide-in-from-right',
              STYLES[t.type],
            ].join(' ')}
          >
            <Icon className="w-5 h-5 shrink-0 mt-0.5" />
            <div className="flex-1 text-sm font-medium">{t.message}</div>
            <button onClick={() => dismiss(t.id)} className="opacity-70 hover:opacity-100">
              <X className="w-4 h-4" />
            </button>
          </div>
        )
      })}
    </div>
  )
}
